import axios from 'axios'

const config = {
  baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

// tslint:disable-next-line: variable-name
const _axios = axios.create(config)

_axios.interceptors.request.use(
    (conf) => {
        return conf
    },
    (error) => Promise.reject(error)
)

_axios.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default {
    axios: _axios
}